export default {
    active: $localize `Active`,
    inactive: $localize `Inactive`,
}